"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharSchema = exports.BooleanSchema = void 0;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class BooleanSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Boolean);
        this.apply(objectInitializer);
    }
}
exports.BooleanSchema = BooleanSchema;
class CharSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Char);
        this.apply(objectInitializer);
    }
}
exports.CharSchema = CharSchema;
//# sourceMappingURL=primitive.js.map